import React, { useState, useEffect } from 'react';
import { Col, Row, Table } from 'react-bootstrap';
import '../../../styles/RegDashboard.css';
import { HHIEButton } from '../../utility/HHIEButton';
import { PasswordChangeModal } from './Modals/PasswordChangeModal';
import { SendTemporaryResetEmailModal } from './Modals/SendTemporaryResetEmailModal';
import { ContentBox } from './utility/ContentBox';
import { ContentTitle } from './utility/ContentTitle';

export function POCTable(props) {
    const [user, setUser] = useState(null);
    const [users, setUsers] = useState(null);

    useEffect(() => {
        setUser(props.user);
        setUsers(props.users);

    }, [props]);

    const renderUsers = () => {
        return users.map((poc, idx) => {
            const isLoggedInPoc = poc.email === user.userID;
            // const pocIsOnboarded = pocExistsInDatabase(poc.email);
            return (
                <tr key={"user" + idx}>
                    <td>{poc.firstName} {poc.middleName} {poc.lastName}</td>
                    <td>{poc.status}</td>
                    <td>{(user.isPOCUser && isLoggedInPoc) ? "Self" : ""}</td>
                    <td style={{ margin: 'auto', textAlign: 'right' }}>
                        {user.isPOCUser && isLoggedInPoc && <PasswordChangeModal />}
                        {!(user.isPOCUser && isLoggedInPoc) && poc.status === "Active" && <SendTemporaryResetEmailModal poc={poc} user={user}/>
                            
                        }
                    </td>
                    {/* <td>{pocIsOnboarded. ? "Yes" : "No"}</td> */}
                </tr>
            )
        })
    };

    return (<>
        <ContentBox>
            <Row>
                <ContentTitle
                    position="left"
                    title="Points of Contact"
                />
            </Row>
            <Table
                id="users-table"
                className="users-table"
                striped
                bordered
                hover
                responsive="sm"
                variant="light">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Status</th>
                        <th></th>
                        <th></th>
                        {/* <th>Registered</th> */}
                    </tr>
                </thead>
                <tbody>
                    {users ? renderUsers() : <></>}
                </tbody>
            </Table>
        </ContentBox>
    </>
    );
}
